import { XMarkIcon } from '@heroicons/react/20/solid';

import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader
} from 'src/shared/components/ui';
import { ButtonV2, Typography } from 'src/shared/components/ui';

interface CavelaManufacturingDrawerProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Slide-over drawer that surfaces information about Cavela Manufacturing.
 * Opened from the "Made by: Cavela Manufacturing" link in the Cavela Direct
 * quote summary. Content is intentionally placeholder for now — fill in
 * real copy / data wiring in a follow-up.
 */
const CavelaManufacturingDrawer: React.FC<CavelaManufacturingDrawerProps> = ({
  isOpen,
  onOpenChange
}) => {
  return (
    <Drawer
      hideCloseButton
      isOpen={isOpen}
      placement="right"
      size="2xl"
      onOpenChange={onOpenChange}
    >
      <DrawerContent>
        {(onClose) => (
          <>
            <DrawerHeader className="flex justify-between items-center border-b border-gray-4">
              <Typography variant="h3" weight="bold" className="ml-3">
                Cavela Manufacturing
              </Typography>
              <ButtonV2
                size="md"
                onPress={() => onClose()}
                isIconOnly
                color="tertiary"
              >
                <XMarkIcon className="size-4" />
              </ButtonV2>
            </DrawerHeader>
            <DrawerBody className="px-8 pt-6 pb-10 space-y-8">
              <section className="space-y-2">
                <Typography variant="h4" weight="bold" as="h3">
                  About
                </Typography>
                <Typography
                  variant="body-1"
                  as="p"
                  className="text-secondary-text leading-relaxed"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. A
                  short overview of Cavela Manufacturing goes here — who we are,
                  what we do, and why customers choose us.
                </Typography>
              </section>

              <section className="space-y-2">
                <Typography variant="h4" weight="bold" as="h3">
                  Capabilities
                </Typography>
                <Typography
                  variant="body-1"
                  as="p"
                  className="text-secondary-text leading-relaxed"
                >
                  Lorem ipsum dolor sit amet. Describe production capabilities,
                  materials handled, MOQ ranges, and typical lead times.
                </Typography>
              </section>

              <section className="space-y-2">
                <Typography variant="h4" weight="bold" as="h3">
                  Locations
                </Typography>
                <Typography
                  variant="body-1"
                  as="p"
                  className="text-secondary-text leading-relaxed"
                >
                  Lorem ipsum dolor sit amet. List factories, cities, and any
                  regional partners that power Cavela Manufacturing.
                </Typography>
              </section>

              <section className="space-y-2">
                <Typography variant="h4" weight="bold" as="h3">
                  Certifications
                </Typography>
                <Typography
                  variant="body-1"
                  as="p"
                  className="text-secondary-text leading-relaxed"
                >
                  Lorem ipsum dolor sit amet. Surface quality, social, and
                  environmental certifications (e.g. ISO 9001, BSCI, GOTS).
                </Typography>
              </section>
            </DrawerBody>
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default CavelaManufacturingDrawer;
